module.exports = __webpack_public_path__ + "c022069f87662608457d4facac66ead5.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1044
// module chunks = 0